import { Contract } from '@ethersproject/contracts';
import config from './config';
import { getPublicRpcProvider } from './hooks/usePassiveIncome';

const CHUNK_SIZE = 10;

export const fetchUserIdsByAddresses = async (addresses = [], walletProvider = null) => {
  const provider = walletProvider || getPublicRpcProvider();
  if (!provider || !config.contractMatrixX2X4) {
    return {};
  }

  const unique = [...new Set(addresses.filter(Boolean).map((addr) => String(addr).toLowerCase()))];
  if (!unique.length) {
    return {};
  }

  const contract = new Contract(config.contractMatrixX2X4, config.contractMatrixX2X4Abi, provider);
  const map = {};

  for (let i = 0; i < unique.length; i += CHUNK_SIZE) {
    const chunk = unique.slice(i, i + CHUNK_SIZE);
    await Promise.all(
      chunk.map(async (addr) => {
        try {
          const info = await contract.users(addr);
          const id = Number(info.id);
          map[addr] = Number.isFinite(id) && id > 0 ? id : null;
        } catch {
          map[addr] = null;
        }
      }),
    );
  }

  return map;
};
